import { calculateBuildingOwnershipDotValues } from "./calculateBuildingOwnershipDotValues";
import { calculateEasementsDotValues } from "./calculateEasementsDotValues";
import { calculateBuildingPlansInfoDotValues } from "./calculateBuildingPlansInfoDotValues";
import { calculateBuildingVisualInspectionDotValues } from "./calculateBuildingVisualInspectionDotValues";
import { calculateCadastreStatusDotValues } from "./calculateCadastreDotValues";
import { calculateBuildingClimatisationDotValues } from "./calculateClimatisationDotValuesForBuilding";
import { calculateDangerousMaterialsInfoDotValues } from "./calculateDangerousMaterialsInfoDotValues";
import { calculateElectricityDotValues } from "./calculateElectricityDotValues";
import { calculateElevatorDotValues } from "./calculateElevatorDotValues";
import { calculateEnergyPerformanceDotValues } from "./calculateEnergyPerformanceDotValues";
import { calculateFireSecurityBuildingDotValues } from "./calculateFireSecurityBuildingDotValues";
import { calculateInsuranceDotValues } from "./calculateInsuranceDotValues";
import { calculatePermitStatusDotValues } from "./calculatePermitsDotValues";
import { calculateSoilStatusDotValues } from "./calculateSoilDotValues";
import { calculateStabilityInfoDotValues } from "./calculateStabilityInfoDotValues";
import { calculateWaterBuildingInfoStatus } from "./calculateWaterInfoDotValues";
import { calculateTaxationDotValues } from "./calculateTaxationDotValues";

export const getNumericValuesForBuilding = async (entity: any, column: any, session: any) => {

    console.log(entity);

    const mergeDotValues = (dotValuesList: any) => {
        return dotValuesList.reduce((acc: any, dotValues: any) => {
            Object.keys(dotValues).forEach(color => {
                acc[color].count += dotValues[color].count;
                acc[color].labels = [...acc[color].labels, ...dotValues[color].labels];
            });
            return acc;
        }, {
            red: { count: 0, labels: [] },
            orange: { count: 0, labels: [] },
            green: { count: 0, labels: [] },
            transparent: { count: 0, labels: [] },
        });
    };

    if (column === 'Cumulative') {
        // Collect all dotValues in an array
        const allDotValues = await Promise.all([
            calculateElectricityDotValues(entity.electricityInfo || {}, session),
            calculateFireSecurityBuildingDotValues(entity.fireSecurityBuildingInfo || {}),
            calculateWaterBuildingInfoStatus(entity.waterBuildingInfo || {}),
            calculateEnergyPerformanceDotValues(entity || {}, session),
            calculatePermitStatusDotValues(entity.regulatoryInfo || {}, entity || {}, session),
            calculateCadastreStatusDotValues(entity.regulatoryInfo || {}, entity || {}, session),
            calculateInsuranceDotValues(entity.buildingOwnershipInfo || {}),
            calculateSoilStatusDotValues(entity || {}, session),
            calculateElevatorDotValues(entity.commonInstallationsInfo || {}),
            calculateDangerousMaterialsInfoDotValues(entity || {}, session),
            calculateStabilityInfoDotValues(entity.buildingInspectionInfo || {}, entity || {}, session),
            calculateBuildingPlansInfoDotValues(entity || {}, session),
            calculateBuildingVisualInspectionDotValues(entity.buildingInspectionInfo || {}),
            calculateBuildingOwnershipDotValues(entity || {}, session),
            calculateEasementsDotValues(entity || {}),
            calculateTaxationDotValues(entity || {}, session),
        ].filter(dotValues => dotValues !== null)); // Filter out nulls in case some info is not available

        // Merge all dotValues into a single cumulative result
        return mergeDotValues(allDotValues);
    }

    if (column === "Klimatisatie") {
        return calculateBuildingClimatisationDotValues({ buildingClimatisationInfo: entity.climatisationInfo || {} });
    }

    if (column === 'Elektriciteit') {
        return await calculateElectricityDotValues(entity.electricityInfo || {}, session);
    }

    if (column === 'Brandveiligheid') {
        return calculateFireSecurityBuildingDotValues(entity.fireSecurityBuildingInfo || {});
    }

    if (column === 'Waterhuishouding') {
        return calculateWaterBuildingInfoStatus(entity.waterBuildingInfo || {});
    }

    if (column === 'Verzekeringen') {
        return calculateInsuranceDotValues(entity.buildingOwnershipInfo || {});
    }

    if (column === 'Energieprestaties') {
        return calculateEnergyPerformanceDotValues(entity || {}, session);
    }

    if (column === 'Erfdienstbaarheden') {
        return calculateEasementsDotValues(entity || {});
    }

    if (column === 'Stedenbouw') {
        return calculatePermitStatusDotValues(entity.regulatoryInfo || {}, entity || {}, session);
    }

    if (column === 'Kadaster') {
        return calculateCadastreStatusDotValues(entity.regulatoryInfo || {}, entity || {}, session);
    }

    if (column === 'Bodem') {
        return calculateSoilStatusDotValues(entity || {}, session);
    }

    if (column === 'Lift' && entity.commonInstallationsInfo) {
        return calculateElevatorDotValues(entity.commonInstallationsInfo || {});
    }

    if (column === 'Gevaarlijke stoffen') {
        return calculateDangerousMaterialsInfoDotValues(entity || {}, session);
    }

    if (column === 'Stabiliteit') {
        return calculateStabilityInfoDotValues(entity.buildingInspectionInfo || {}, entity || {}, session);
    }

    if (column === 'Plannen') {
        return calculateBuildingPlansInfoDotValues(entity || {}, session);
    }

    if (column === 'Vis. inspectie') {
        return calculateBuildingVisualInspectionDotValues(entity.buildingInspectionInfo || {});
    }

    if (column === 'Eigendom') {
        return calculateBuildingOwnershipDotValues(entity || {}, session);
    }

    if (column === 'Taxatie') {
        return calculateTaxationDotValues(entity || {}, session);
    }

    // Default values if no specific logic is defined for the column
    let dotValues = {
        red: { count: 0, labels: [] as any[] },
        orange: { count: 0, labels: [] as any[] },
        green: { count: 0, labels: [] as any[] },
        transparent: { count: 0, labels: [] as any[] },
    };

    return dotValues;
};
